<template>
    <div class="doubal-slider-box " >
        <div class="range-slider" >
            <span 
            ref="track" 
            :class="`slider-track`" 
            :style="`${global.isRTL?
                `right:${minValPosition}; left:${maxValPosition};`:
                `left:${minValPosition}; right:${maxValPosition};`
            }`" 
            ></span>
            <input 
                @input="slideMin" 
                v-model="minVal"  
                type="range" 
                class="min-val " 
                name="min-val" 
                :min="minLimit" 
                :max="maxLimit" 
            >
            <input 
                @input="slideMax" 
                v-model="maxVal" 
                type="range" 
                class="max-val" 
                name="max-val"  
                :min="minLimit" 
                :max="maxLimit" 
            >
            <div 
                contenteditable="false" 
                @input="(e)=>{
                    e.target.innerText = e.target.innerText.replace(/[^0-9]/g, '')
                    if(e.target.innerText<minLimit){
                        e.target.innerText=minLimit
                        minVal=e.target.innerText
                    }
                    else{
                        minVal=e.target.innerText
                    }
                }"
                :class="` tooltip min-tooltip right-0 ltr:right-auto ltr:left-0`" >
                {{minVal}}
            </div>
            <div 
                contenteditable="false" 
                @input="(e)=>{
                    e.target.innerText = e.target.innerText.replace(/[^0-9]/g, '')
                    if(e.target.innerText>maxLimit){
                        e.target.innerText=maxLimit
                        maxVal=e.target.innerText
                    }else{
                        maxVal=e.target.innerText
                    }
                }" 
                :class="`tooltip max-tooltip left-0 ltr:left-auto ltr:right-0`" >
                {{maxVal}}
            </div>
        </div>
    </div>
</template>

<script>
import { useGlobalStore } from '@/store/Modules/global';

export default {
    props:{
        thumbSize: {
            type: Number,
            required: true,
            default: () => 15
        },
        rangeLimit:{
            type: Object,
            required: true,
            default: () => ({min:0,max:10000}) 
        },
        rangeValue:{
            type: Object,
            required: true,
            immediate:true 
        }
    },
    setup() {
        const global = useGlobalStore()
        const {isRTL}=global
        return {global,};
    },
    data() {
        return {
            minVal:this.rangeValue.min,
            maxVal:this.rangeValue.max,

            minGap:0,//this.thumbSize*50,

            minLimit:this.rangeLimit.min,
            maxLimit:this.rangeLimit.max,
        };
    },
    mounted(){
        this.minVal= this.rangeValue.min
        this.maxVal= this.rangeValue.max
    },
    updated(){
        this.minVal= this.rangeValue.min
        this.maxVal= this.rangeValue.max
        
        this.minLimit=this.rangeLimit.min
        this.maxLimit=this.rangeLimit.max

    },
    watch:{
        minVal(){
            this.$emit('setRangeValue',this.minVal,this.maxVal)

        },
        maxVal(){
            this.$emit('setRangeValue',this.minVal,this.maxVal)
        }
    },
    computed: {
        minValPosition(){
            return ((this.minVal/this.maxLimit))*100+'%' //convert min val to postion in track range
        },
        maxValPosition(){
            return 100-(this.maxVal/this.maxLimit)*100+'%' //convert max val to postion in track range
        }
    },
    methods: {
        slideMin(){
            let gap=parseInt(this.maxVal)-parseInt(this.minVal)
            if(gap<this.minGap){
                this.minVal= parseInt(this.maxVal)-this.minGap
            }
        },
        slideMax(){
            let gap=parseInt(this.maxVal)-parseInt(this.minVal)
            if(gap<this.minGap){
                this.maxVal=parseInt(this.minVal)+ this.minGap
            }

        },
    }
    };
</script>

<style scoped>
.doubal-slider-box{
    background-color: #fff;
    border-radius: 10px;
    width: 100%;
    /*max-width: 20rem;*/
    padding: 20px 40px;
}
.range-slider{
    position: relative;
    height: 3px;
    width: 100%;
    background-color: #808080;
    border-radius: 5px;
}
.slider-track{
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: #0963FF;
}
.range-slider input{
    appearance: none;

    position: absolute;
    width: 100%;
    background: none;
    pointer-events: none;
    top: 50%;
    transform: translateY(-50%);
}
input[type="range"]::-webkit-slider-thumb{
    appearance: none;

    height: v-bind(thumbSize+'px');
    width: v-bind(thumbSize+'px');
    border-radius: 50%;
    border: 1px solid #fff;
    cursor: pointer;
    pointer-events: auto;

}
input[type="range"]::-moz-range-thumb{
    -moz-appearance: none;

    height: v-bind(thumbSize+'px');
    width: v-bind(thumbSize+'px');
    border-radius: 50%;
    border: 1px solid #fff;
    cursor: pointer;
    pointer-events: auto;
}

.tooltip{
    border-image-repeat: .25rem;
    display: block;
    position: absolute;
    bottom: -95%;
    padding: .3rem .3rem;

    border: 0px;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: .75rem;
    line-height: 1.2;
    box-shadow: #00000018 0px 2px 4px 0px inset;
    color: #545454;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
}
.min-tooltip{
    transform: translateX(0%) translateY(150%);
    z-index: 5;
}
.max-tooltip{
    transform: translateX(-15%) translateY(150%);
}

</style>
